<template>
  <dl class="boss-scout-send-wrap">
    <dt class="boss-scout-send-left">
      メッセージ<br>
      <small>({{ maxToLocale }}文字以内)</small>
    </dt>
    <dd class="boss-scout-send-right">
      <textarea
        :value="value"
        :class="{ 'is-invalid-input': isOverLength }"
        :disabled="disabled"
        class="pega-send-message-edit"
        data-test="message"
        @input="$emit('input', $event.target.value)"
      />
      <span
        v-if="isOverLength"
        style="margin: 0"
        class="form-error is-visible"
        data-test="max-error-message-body"
      >本文は{{ max }}文字以内で入力してください</span>
    </dd>
  </dl>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    isOverLength: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    maxToLocale () {
      return this.max.toLocaleString()
    }
  }
}
</script>
